// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"24":"2affc4c6","71":"bf773785","249":"6eccd883"}[chunkId] + ".js";
};